export default () => ({
  component: 'providers-filter',
  componentAttrs: {
    clearable: true,
    'persistent-border': true,
  },
});
